import ReactDOM from 'react-dom/client';

import DialogPopup from './DialogPopup';

let inflight: Promise<void> | null = null;

type Props = {
  onConfirmClick: () => void;
  onCancelClick: () => void;
};

export function makeDialogPopup({ onCancelClick, onConfirmClick }: Props) {
  if (!inflight) {
    inflight = new Promise(() => {
      const container = document.createElement('div');
      container.setAttribute('id', 'modal-root');
      container.style.position = 'absolute';
      container.style.top = '0';
      container.style.right = '0';
      container.style.bottom = '0';
      container.style.left = '0';
      container.style.zIndex = '1000';

      document.body.appendChild(container);

      const root = ReactDOM.createRoot(container);

      root.render(
        <DialogPopup
          onCancelClick={onCancelClick}
          onConfirmClick={onConfirmClick}
        />
      );
    });
  }

  return inflight;
}
